import {DescriptionText, H1Text, H2Text} from "../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";

type Props = {
  payment: Object,
  whiteLabel: Boolean,
  bankImageUrl: String,
  eventDetails: Object,
  amountInfo: String,
  selectedSeats: Array<Object>,
}

const Header = (props:Props) => {
  const { payment, bankImageUrl, whiteLabel, eventDetails, amountInfo } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  return (
    <SmallScreenHeader paymentCheckout={true} bankImageUrl={bankImageUrl} largeLogo={largeLogo} whiteLabel={whiteLabel}>
      <H1Text>
        Payment Checkout
      </H1Text>
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText fontSize="24px">
        {amountInfo ? amountInfo : null }
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
